import { Injectable, Injector } from "@angular/core";
import { QueryNodeMessageBox } from "../QueryNodeMessageBox";
import { FieldDefinitionConditions } from "../../../../../sections/webtrader/webtrader/message/fieldDefinition-conditions";
import { ServiceEnum } from "../../../ServiceEnum";
import { EntityEnum } from "../../EntityEnum";
import { ResultListNodeToEudravigilance } from "../ListEntity/ResultListNodeToEudravigilance";
import { ToEudravigilanceListView } from "../../../Data/WebTraderData/ToEudravigilanceListView";
import { QueryConditionNodeToEudravigilance } from "./QueryConditionNodeToEudravigilance";

@Injectable({
  providedIn: 'root',
})
export class QueryNodeToEudravigilance extends QueryNodeMessageBox {

  constructor(injector: Injector) {
    super(injector, new ToEudravigilanceListView([]), 'To Eudravigilance', EntityEnum.toEV, ServiceEnum.Webtrader);
    this.children!.push(new QueryConditionNodeToEudravigilance(injector, new FieldDefinitionConditions(injector).queryToEudravigilanceConditions));
    this.children!.push(new ResultListNodeToEudravigilance(injector));
  }

  override reset(): void {
    this.children = [];
    this.children!.push(new QueryConditionNodeToEudravigilance(this.ioc!, new FieldDefinitionConditions(this.ioc!).queryToEudravigilanceConditions));
    this.children!.push(new ResultListNodeToEudravigilance(this.ioc!));
  }

}